package pt.at.oss.kotlin.manual.storage.common.contactname.suffixes

import kotlinx.serialization.Serializable
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * SuffixesEntry Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class SuffixesEntry(
    var name: String = ""
) : BaseRecord()
